import { useState } from "react";

export default function useCopyText(value: string) {
  const [isCopied, setIsCopied] = useState(false);

  function copyText() {
    navigator.clipboard.writeText(value).then(() => {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    });
  }
  return { isCopied, copyText };
}
